import { gql } from "apollo-boost";

export const CHEF_DAY_SCHEDULES = gql`
  query chefDaySchedule($chefId: ID!, $date: Date!) {
    chefDaySchedule(chefId: $chefId, date: $date) {
      date
      available
      slots {
        start
        end
      }
    }
  }
`;

export const GET_CALENDAR_SLOTS = gql`
  query getCalendarSlots($chefId: ID!, $start: Date!, $end: Date!) {
    getCalendarSlots(chefId: $chefId, start: $start, end: $end) {
      date
    }
  }
`;
